import { styled } from '@mui/material';
import { Typography, Icon } from 'core/common/ui/ui-kit';

export const TypographyStyled = styled(Typography)`
  margin-bottom: 20px;
  text-align: center;
  ${({ theme }) => theme.breakpoints.up('mobile')} {
    margin-bottom: 40px;
  }
`;

export const ItemStyled = styled('li')`
  display: flex;
  align-items: center;
`;

export const IconStyled = styled(Icon)`
  margin-right: 7px;
  fill: ${({ theme }) => theme.palette.background.secondary};
`;
